// Presentation-only color system for iq-report.
//
// No scoring/business logic lives here — these functions only ever consume
// an already-computed domain key or an already-supplied classification
// `bandKey` (see report-model.js). They decide paint, nothing else.

const DOMAIN_STYLES = {
  pattern_recognition: { text: "text-sky-300", bg: "bg-sky-300", fill: "fill-sky-300", dot: "bg-sky-400" },
  verbal_reasoning: { text: "text-violet-300", bg: "bg-violet-300", fill: "fill-violet-300", dot: "bg-violet-400" },
  numerical_reasoning: { text: "text-orange-400", bg: "bg-orange-400", fill: "fill-orange-400", dot: "bg-orange-400" },
  logical_deduction: { text: "text-amber-300", bg: "bg-amber-300", fill: "fill-amber-300", dot: "bg-amber-300" },
};

const DEFAULT_DOMAIN_STYLE = {
  text: "text-neutral-300",
  bg: "bg-neutral-300",
  fill: "fill-neutral-300",
  dot: "bg-neutral-400",
};

export const getDomainVisualStyle = (domainKey) =>
  DOMAIN_STYLES[domainKey] || DEFAULT_DOMAIN_STYLE;

const DEFAULT_BAND_STYLE = { badgeBg: "bg-amber-300", badgeText: "text-neutral-900" };

// Color per PSYCHOMETRIC (deviation/IQ index) classification — keyed by
// iq-psychometric-config.js's PSYCHOMETRIC_CLASSIFICATION_BANDS `key`.
// This vocabulary is distinct from the 5-key percentage performance bands
// (below_average/.../above_average) shown as text in Section Scores —
// the two share the word "average" but are different scales; never
// cross-reference one map with the other's key.
const PSYCHOMETRIC_BAND_STYLES = {
  extremely_low: { badgeBg: "bg-neutral-200", badgeText: "text-neutral-900" },
  very_low: { badgeBg: "bg-neutral-200", badgeText: "text-neutral-900" },
  low_average: { badgeBg: "bg-sky-100", badgeText: "text-neutral-900" },
  average: { badgeBg: "bg-sky-200", badgeText: "text-neutral-900" },
  high_average: { badgeBg: "bg-amber-200", badgeText: "text-neutral-900" },
  very_high: { badgeBg: "bg-amber-300", badgeText: "text-neutral-900" },
  extremely_high: { badgeBg: "bg-amber-300", badgeText: "text-neutral-900" },
};

export const getPsychometricBandVisualStyle = (classificationKey) =>
  PSYCHOMETRIC_BAND_STYLES[classificationKey] || DEFAULT_BAND_STYLE;
